import React from 'react';
import './ModelBox.scss';
import { AdminMonitorStatsResponse } from '../../../../shared/models/admin/dashboard/AdminMonitorStatsResponse';
import { MonitorType } from '../../../../shared/types/monitor/MonitorType';
import { formatCount } from '../formatCount';
import { getMonitorTypeIcon } from '../../../prompt/preview/components/stats/helpers/StatsHelper';

interface ModelBoxProps {
  monitorType: MonitorType;
  stats: AdminMonitorStatsResponse | null;
  header: string;
  isToday: boolean;
}

// Progress colour: little collected → red, halfway → orange, (almost) done → green.
const progressModifier = (percent: number): string => {
  if (percent >= 90) {
    return 'model-box__bar-fill--high';
  }
  return percent >= 50 ? 'model-box__bar-fill--mid' : 'model-box__bar-fill--low';
};

const ModelBox: React.FC<ModelBoxProps> = ({ monitorType, stats, header, isToday }) => {
  if (!stats) {
    return <></>;
  }

  // pg COUNT arrives as a string on the wire.
  const total = Number(stats.totalMonitors);
  const collected = Number(stats.alreadyCollected);
  const remaining = Number(stats.remainingToCollect);
  // Rounded down and capped at 99 while anything is left: 14 771 / 14 805 (99.8%) must not read as "100%".
  const percent =
    total > 0 ? Math.min(Math.floor((collected / total) * 100), remaining > 0 ? 99 : 100) : 100;
  const icon = getMonitorTypeIcon(monitorType);

  return (
    <div className="model-box">
      <div className="model-box__header">
        {icon && <span className={`ico ico--md ${icon} model-box__icon`} />}
        <span className="model-box__name">{header}</span>
      </div>
      <div className="model-box__row">
        <span>All questions</span>
        <span>{formatCount(total)}</span>
      </div>
      <div className="model-box__row">
        <span>{isToday ? 'Done' : 'Collected'}</span>
        <span>{formatCount(collected)}</span>
      </div>
      <div className="model-box__row">
        <span>{isToday ? 'To do' : 'Not collected'}</span>
        <span>{formatCount(remaining)}</span>
      </div>
      <div className="model-box__progress">
        <div className="model-box__bar">
          <div
            className={`model-box__bar-fill ${progressModifier(percent)}`}
            style={{ width: `${percent}%` }}
          />
        </div>
        <span className="model-box__percent">{percent}%</span>
      </div>
    </div>
  );
};

export default ModelBox;
